import { apiHandlerWithError } from 'api/apiHandler';

export default async function patchCalendar(id, body) {
  return await apiHandlerWithError.patch(`calendars/${id}`, body);
}
